import React, { FC, ReactElement } from 'react';
import Title from '@/components/Title';
import './style.less';

interface Props {
    children: ReactElement;
    title: string;
}

const KfLayout: FC<Props> = (props) => {
    const { children, title } = props;

    return (
        <div className="kf_view">
            <div className="kf_view_bg">
                <div className="kf_view_content">
                    <Title title={title} style={{ paddingLeft: 0 }} content={<a className="title_ques"></a>} />
                    {children}
                </div>
            </div>
        </div>
    )
}

export default KfLayout;